import { render, staticRenderFns } from "./addEmployer.vue?vue&type=template&id=6fdfe30d&scoped=true"
import script from "./addEmployer.vue?vue&type=script&lang=js"
export * from "./addEmployer.vue?vue&type=script&lang=js"
import style0 from "./addEmployer.vue?vue&type=style&index=0&id=6fdfe30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfe30d",
  null
  
)

export default component.exports